/**
 * WILL BE REPLACE by `src/utils/challenge/challengeConstants.js` `SOCIAL_CHALLENGE_TYPE_ID`
 * @enum {number}
 */
export const SOCIAL_CHALLENGE_TYPE = {
    GROUP_CHALLENGE: 1,
    ADHOC_CHALLENGE: 2,
    VIVOKID_CHALLENGE: 3,
    TEAM_STEPS_VIVOKID_CHALLENGE: 4
};

/**
 * @enum {number} ChallengeCategory enum
 * ref: ChallengeCategory.java
 */
export const CHALLENGE_CATEGORY_ID = {
    RUNNING: 1,
    CYCLING: 2,
    SWIMMING: 3,
    WELLNESS_STEPS_COUNT: 4,
    WALKING: 5,
    YOGA: 6,
    STRENGTH: 7,
    HIKING: 8,
    FITNESS_COMPOSITE: 9,
    CHALLENGE_COMPOSITE: 10,
    CARDIO: 11,
    VIRTUAL_HIKE: 12,
    VIRTUAL_CLIMB: 13,
    SOCIAL: 14,
    HEALTH_AND_WELLNESS: 15,
    GC: 16,
    TRIATHLON: 17
};

export const DURATION_TYPE = {
    ONE_DAY: 4,
    WEEKEND: 3,
    WEEK: 0,
    MONTH: 1,
    CUSTOM: 2
};

export const DURATION_TYPE_TO_IMAGE_KEY = {
    [DURATION_TYPE.ONE_DAY]: 'custom',
    [DURATION_TYPE.WEEKEND]: 'custom',
    [DURATION_TYPE.WEEK]: 'week',
    [DURATION_TYPE.MONTH]: 'month',
    [DURATION_TYPE.CUSTOM]: 'custom'
};

/**
 * WILL BE REPLACE by `src/utils/challenge/challengeConstants.js`
 *
 * @enum {number} challenge activity type id
 * ref: SocialChallengeActivityType.java
 */
export const CHALLENGE_ACTIVITY_TYPE_ID = {
    WALKING: 0,
    RUNNING: 1,
    CYCLING: 2,
    SWIMMING: 3,
    WELLNESS_STEPS_COUNT: 4,
    WELLENSS_STEPS_DISTANCE: 5,
    CALORIES_BURNED: 6,
    ACTIVE_MINUTES: 7,
    GOALS: 8,
    WELLNESS_STEPS_COUNT_TEAMS_AVERAGE: 9,
    WELLNESS_PUSHES_COUNT: 10,
    /**
     * para_sports
     */
    PUSHING_DISTANCE: 11
};

export const PICTURE_PATH_TYPES = {
    [CHALLENGE_ACTIVITY_TYPE_ID.WALKING]: 'walking',
    [CHALLENGE_ACTIVITY_TYPE_ID.RUNNING]: 'running',
    [CHALLENGE_ACTIVITY_TYPE_ID.CYCLING]: 'cycling',
    [CHALLENGE_ACTIVITY_TYPE_ID.SWIMMING]: 'swimming',
    [CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_STEPS_COUNT]: 'steps',
    [CHALLENGE_ACTIVITY_TYPE_ID.WELLENSS_STEPS_DISTANCE]: 'steps_distance',
    [CHALLENGE_ACTIVITY_TYPE_ID.CALORIES_BURNED]: 'calories',
    [CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_PUSHES_COUNT]: 'pushes',
    [CHALLENGE_ACTIVITY_TYPE_ID.PUSHING_DISTANCE]: 'para_sports'
};

/**
 * @enum {string} chip filter key
 */
export const CHIP_FILTER_KEY = {
    ALL_CHALLENGES: 'all_challenges',
    ADVENTURES: 'adventures',
    STEPS: 'steps',
    RUNNING: 'running',
    CYCLING: 'cycling',
    STRENGTH: 'strength',
    SWIMMING: 'swimming',
    WALKING: 'walking',
    HIKING: 'hiking',
    YOGA: 'yoga',
    CARDIO: 'cardio',
    PUSHES: 'wheelchair_pushes',
    PARASPORTS: 'para_sports',
    HEALTH_AND_WELLNESS: 'health_and_wellness',
    SOCIAL: 'social',
    GC: 'gc'
};

/**
 * chip filter list
 */
export const chips = [
    { type: CHIP_FILTER_KEY.ADVENTURES, ns: 'challengewidget', content: 'expeditions' },
    { type: CHIP_FILTER_KEY.STEPS, ns: 'activity_types', content: 'activity_type_steps' },
    { type: CHIP_FILTER_KEY.RUNNING, ns: 'activity_types', content: 'activity_type_running' },
    { type: CHIP_FILTER_KEY.CYCLING, ns: 'activity_types', content: 'activity_type_cycling' },
    { type: CHIP_FILTER_KEY.STRENGTH, ns: 'workout', content: 'workout.strength' },
    { type: CHIP_FILTER_KEY.SWIMMING, ns: 'activity_types', content: 'activity_type_swimming' },
    { type: CHIP_FILTER_KEY.WALKING, ns: 'activity_types', content: 'activity_type_walking' },
    { type: CHIP_FILTER_KEY.HIKING, ns: 'activity_types', content: 'activity_type_hiking' },
    { type: CHIP_FILTER_KEY.YOGA, ns: 'activity_types', content: 'activity_type_yoga' },
    { type: CHIP_FILTER_KEY.PUSHES, ns: 'activity_types', content: 'activity_type_wheelchair_pushes' },
    { type: CHIP_FILTER_KEY.PARASPORTS, ns: 'activity_types', content: 'activity_type_para_sports' },
    {
        type: CHIP_FILTER_KEY.HEALTH_AND_WELLNESS,
        ns: 'badgechallenge',
        content: 'challenge_filter.option_health_and_wellness'
    },
    { type: CHIP_FILTER_KEY.SOCIAL, ns: 'badgechallenge', content: 'challenge_filter.option_social' },
    { type: CHIP_FILTER_KEY.GC }
];

export const gcPlusExBadgeChipTypes = [CHIP_FILTER_KEY.HEALTH_AND_WELLNESS, CHIP_FILTER_KEY.SOCIAL, CHIP_FILTER_KEY.GC];

export const BADGE_CHALLENGE_STATUS = {
    READY: 0,
    STARTED: 1,
    STOPPED: 2,
    LOCKED: 3,
    COMPLETED: 4,
    FULL: 5
};
